import {connect} from 'react-redux';
import Component from './Component'
import _ from 'lodash';

export default connect(
  (state) => ({
    me: _.get(state, 'me'),
  })
)(Component);



/** WEBPACK FOOTER **
 ** ./src/app/modules/sidebar/components/Container.js
 **/